import axios, { AxiosPromise } from 'axios';
import { IPackLine } from '../../../@types/model/masterData/packLine/packLine';


export default class PackLineHttpService {
    public static getPackLineData() : AxiosPromise<Array<IPackLine>> {
        return axios.get(`${API_URL}/v1/PackLine/GetAllWeb`);
    }

    public static addOrUpdatePackLine(data : IPackLine) : AxiosPromise<IPackLine> {
        return axios.post(`${API_URL}/v1/PackLine/PostPackLine`, data);
    }

    public static deletePackLine(packLineId : number) : AxiosPromise<IPackLine> {
        return axios.delete(`${API_URL}/v1/PackLine/Delete`, {
            params : { packLineId },
        });
    }
}
